module.exports = __webpack_public_path__ + "img/joel-make-time@2x.a51f4258.png";